<template>
	<div class="switch-container">
		<div v-if="twoLabelsMode" :class="leftLabelClasses">{{ leftLabel }}</div>
		<Switch v-bind="filteredAttrs" v-model:checked="checkedValue" :class="switchClasses" :size="smallRef ? 'small' : 'default'">
			<template v-if="!twoLabelsMode && !smallRef" #checkedChildren><CheckOutlined /></template>
			<template v-if="!twoLabelsMode && !smallRef" #unCheckedChildren><CloseOutlined /></template>
		</Switch>
		<div :class="rightLabelClasses">{{ rightLabel }}</div>
	</div>
</template>

<script>
import { computed, toRef } from 'vue';
import { Switch } from 'ant-design-vue';
import { CheckOutlined, CloseOutlined } from '@ant-design/icons-vue';

export default {
	components: {
		Switch,
		CheckOutlined,
		CloseOutlined,
	},
	props: {
		leftLabel: {
			type: String,
			default: '',
		},
		rightLabel: {
			type: String,
			default: '',
		},
		loading: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		modelValue: {
			type: Boolean,
			required: true,
		},
		small: {
			type: Boolean,
			required: false,
		},
		allowWordWrap: {
			type: Boolean,
			default: true,
		},
	},
	emits: ['update:modelValue', 'change'],
	setup(props, { emit, attrs }) {
		const modelValueRef = toRef(props, 'modelValue');
		const checkedValue = computed({
			get: () => modelValueRef.value,
			set: value => {
				emit('update:modelValue', value);
				emit('change', value);
			},
		});

		const leftLabelRef = toRef(props, 'leftLabel');
		const twoLabelsMode = computed(() => Boolean(leftLabelRef.value));

		const smallRef = toRef(props, 'small');
		const switchClasses = computed(() => {
			const result = ['switch-ctrl'];
			if (twoLabelsMode.value) {
				result.push('switch-ctrl-ml');
			}
			if (smallRef.value) {
				result.push('switch-ctrl-small');
			}
			return result;
		});

		const allowWordWrapRef = toRef(props, 'allowWordWrap');
		const leftLabelClasses = computed(() => {
			const result = ['switch-label', 'switch-label-left'];
			if (!allowWordWrapRef.value) {
				result.push('nobr');
			}
			return result;
		});

		const rightLabelClasses = computed(() => {
			const result = ['switch-label'];
			if (!allowWordWrapRef.value) {
				result.push('nobr');
			}
			return result;
		});

		const filteredAttrs = computed(() => {
			const result = {
				...attrs,
				...props,
			}
			delete result.class;
			delete result['data-testid'];
			return result;
		});

		return {
			checkedValue,
			twoLabelsMode,
			switchClasses,
			leftLabelClasses,
			rightLabelClasses,
			smallRef,
			filteredAttrs,
		};
	},
}
</script>

<style scoped>
.switch-container {
	display: flex;
}
.switch-label-left {
	text-align: right;
}
.switch-ctrl {
	margin-inline-end: 16px;
}
.switch-ctrl-ml {
	margin-inline-start: 16px;
}
.switch-ctrl-small {
	margin-block-start: 4px;
}
</style>
